"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.AttributionTag = void 0;
var React = require("react");
var types_1 = require("./types");
var AttributionTag = function (_a) {
    var to = _a.to;
    if ((0, types_1.isLinkAttribution)(to)) {
        return React.createElement("a", { href: to.uri }, to.uri);
    }
    else if ((0, types_1.isPersonAttribution)(to)) {
        return React.createElement(PersonAttributionTag, __assign({}, to));
    }
    else {
        return null;
    }
};
exports.AttributionTag = AttributionTag;
var PersonAttributionTag = function (_a) {
    var webId = _a.webId, name = _a.name, imageSrc = _a.imageSrc;
    return (React.createElement(React.Fragment, null,
        imageSrc && React.createElement("img", { height: "47", width: "47", alt: name, src: imageSrc }),
        React.createElement("a", { href: webId }, name)));
};
//# sourceMappingURL=AttributionTag.js.map